import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    width: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    border: `1px solid ${theme.colors.border1}`,
    borderRadius: theme.radius.medium,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space16,
    padding: theme.spacing.space16,
    boxSizing: "border-box",
  },
  achieveImg: {
    width: 48,
  },
  desc: {
    marginTop: theme.spacing.space8,
  },
}));
